<template>
  <div class="gray-back" style="padding: 0.2rem 0 3rem 0">
    <van-form @submit="onSubmit" @failed="onFailed" v-if="formData.saiqu.need_video==1">
      <van-cell-group >
        <van-cell :value="formData.saiqu.name" title="赛区" />
        <van-cell :value="formData.baoming.danwei" title="单位" />
        <van-cell :value="formData.baoming.mingcheng" title="队伍名称" />
        <van-cell :value="formData.subject_name" title="项目" />

        <van-cell  
         v-if="formData.subject_name.indexOf('活力大课间啦啦操展示')>=0"
                input-align="right"
                label="如果不上传运动员信息，请填写运动员人数"
                title="运动员人数" 
        >  
        <van-stepper  v-if="formData.subject_name.indexOf('活力大课间啦啦操展示')>=0" v-model="formData.yundongyuan_count" integer :min="0" :max="3000"  />

        </van-cell>


        <van-cell v-if="formData.subject_name.indexOf('活力大课间啦啦操展示')>=0" title="导入运动员信息" v-clipboard:copy="pcUrl" value="点击复制网址" 
          
           is-link
                        v-clipboard:success="onCopy"  >
                        <template slot="label">
                            <div style="color: #f00;">如果不填写运动员，后期将无法导出证书。</div>
                        </template>
                        </van-cell>

        <!-- <van-cell   title="上传照片" :value="formData.pic.length+'/1'"  v-if="canSubmit"> -->
        <!--<template slot="icon" >-->
        <!--<van-icon class="question-icon" name="question-o" @click="onQuestion('heying')"/>-->
        <!--</template>-->
        <!-- </van-cell> -->
        <!-- <div class="row"  v-if="canSubmit"> -->
        <!-- <PicUploader :fileList="formData.pic" :limit="1" -->
        <!-- :name="'pic'"></PicUploader> -->
        <!-- </div> -->
        <!-- <div class="operate-desc-left"  v-if="canSubmit">请上传一张照片</div> -->
        <van-cell
            title="视频"
            :value="formData.video.length + '/1'"
            v-if="canSubmit"
        >
          <!--<template slot="icon" >-->
          <!--<van-icon class="question-icon" name="question-o" @click="onQuestion('heying')"/>-->
          <!--</template>-->
        </van-cell>

        <div
            class="row"
            v-if="canSubmit && formData.video.length == 0 && isAndroid && isApp"
            @click.stop="beforeUpload"
        >

          <div class="uploader-wrap" >
            <div class="uploader-content">
              <van-icon name="video" size="24" color="#dcdee0" />
              <div
                  class="uploader-text"
                  style="color: #969799; font-size: 12px"
              >
                上传视频
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-else-if="canSubmit">
          <VideoUploader
              ref="vu"
              :maxSize="formData.saiqu.id==767?500:200"
              :minSize="0"
              :fileList="formData.video"
              :limit="1"
              @onInputClick="onVideoInputClick"
              :fileName="formData.baoming.mingcheng + '-' + formData.subject_name"
              :name="'video'"
          ></VideoUploader>
        </div>
        <!-- <div class="row" v-if="(canSubmit && formData.video.length > 0) || (canSubmit && formData.video.length == 0 && isAndroid && !isApp)">
          <VideoUploader
              ref="vu"
              :maxSize="200"
              :minSize="0"
              :fileList="formData.video"
              :limit="1"
              @onInputClick="onVideoInputClick"
              :fileName="formData.baoming.mingcheng + '-' + formData.subject_name"
              :name="'video'"
          ></VideoUploader>
        </div>
        <div class="row" v-if="(canSubmit && formData.video.length > 0) || (canSubmit && formData.video.length == 0 && !isAndroid)">
          <VideoUploader
              ref="vu"
              :maxSize="200"
              :minSize="0"
              :fileList="formData.video"
              :limit="1"
              @onInputClick="onVideoInputClick"
              :fileName="formData.baoming.mingcheng + '-' + formData.subject_name"
              :name="'video'"
          ></VideoUploader> 
        </div>-->
        <div class="operate-desc-left" v-if="canSubmit && formData.video.length==0">请上传一段视频</div>
        <div class="operate-desc-left" v-if="canSubmit && formData.video.length>0">

        <van-button native-type='button' @click.stop='delVideo( )'>删除视频</van-button>

        <van-button native-type='button' @click.stop='playVideo()' >视频预览</van-button>

        </div>
        <div @click="onDownload" v-show="isApp" style="padding: 10px 15px;background: #fffbe8; color: #ed6a0c">如果视频无法上传，请点击这里下载最新版</div>
        <!-- isApp {{isApp}} isAndroid{{isAndroid}} -->
        <div v-clipboard:copy="pcUrl"   
                        v-clipboard:success="onCopy"
                         style="padding: 10px 15px; margin-top:20px ;background: #fffbe8; color: #333; text-align:center">
          还可以复制以下网址用电脑浏览器上传
          <br>
          {{pcUrl}}
          <br/>
          点击复制
        </div>
      </van-cell-group>

      <div class="savebtn" v-if="canSubmit">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal"
            round
            :disabled="saveLoading"
            :loading="saveLoading"
            loading-text="提交中..."
            @click="submit"
        >提交完成上传</van-button
        >
      </div>
      <!-- {{userAgent}} -->

    </van-form> 
    <LoginDialog
        :show="loginShow"
        @loginSuccess="loginSuccess"
        @loginCancel="loginCancel"
    />
  </div>
</template>
<style scoped>
.uploader-wrap {
  width: 80px;
  height: 80px;
  /*line-height: 80px;*/
  text-align: center;
  background: #f7f8fa;
  border-radius: 8px;
  position: relative;
}

.uploader-content {
  /*width: 100px;*/
  height: 50px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.box {
  /*margin-bottom: 1.5rem;*/
}

.memberResultWrap {
  background: #f3f3f3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}
.memberResultWrap .memberLi {
  font-size: 14px;
  color: #666;
  height: 36px;
  line-height: 36px;
}
.memberResultWrap .memberLi .van-tag {
  width: auto !important;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}
.between {
  justify-content: space-between;
}
</style>
<script>
import Vue from "vue";
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from "@/components/picker/PicUploader.vue";
import VideoUploader from "@/components/picker/VideoUploader.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Dialog,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
    NoticeBar
} from "vant";
import CaipanPicker from "@/components/picker/CaipanPicker.vue";
import JiaolianPicker from "@/components/picker/JiaolianPicker.vue";
import LoginDialog from "@/components/LoginDialog.vue";
import FileUploader from "@/components/picker/FileUploader.vue";

Vue.use(Cell)
    .use(CellGroup)
    .use(Form)
    .use(Divider)
    .use(Area)
    .use(RadioGroup)
    .use(Dialog)
    .use(Radio)
    .use(Icon)
    .use(Toast)
    .use(Popup)
    .use(Picker)
    .use(Sidebar)
    .use(SidebarItem)
    .use(Tag)
    .use(Stepper)
    .use(Field)
    .use(Switch)
    .use(NoticeBar)
    .use(Button);
export default {
  name: "SaiApplyFormStep1",
  components: {
    [Field.name]: Field,
    PicUploader,
    VideoUploader,
    FileUploader,
    CaipanPicker,
    JiaolianPicker,
    LoginDialog,
  },
  data: function () {
    return {
      validator,
      pcUrl:'',
      loginShow: false,
      canSubmit: false,
      saveLoading: false,
      showCaipanPicker: false,
      showJiaolianPicker: false,
      showNumTypePicker: false,
      numTypeColumns: ["身份证", "护照"],
      showArea: false,
      areaList: {},
      areaValue: "",
      submitType: "",
      isApp: window.isApp(),

      isAndroid: this.isAndroid(),
      userAgent:'',
      formData: {
        id: 0,
        baoming: {},
        saiqu: {},
        pic: [],
        is_jizan:2,
        yundongyuan_count:0,
        yundongyuan:[],
        jizan_pic:[],
        jizan_count:0,
        video: [
          {
            name: "xxxx.mov",
            save_name: "h5/2020-05-26/1590474953142781.mov",
            uid: "vc-upload-1590474953142781",
            url: "https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-26/1590474953142781.mov",
          },
        ],
        //                            [{name:"选择商户.png",
        //                        save_name:"h5/2020-05-11/1589187988243621.png",
        //                        uid:"vc-upload-1589187988243621",
        //                        url:"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
        //                    }],
      },
    };
  },
  filters: {},
  mounted() {
    let that = this;
    this.userAgent = navigator.userAgent
    that.formData.id = this.$route.query.id;
    document.title = "上传视频";
    that.pcUrl = PcRoot+'isai-apply-form-upload-video?from=app&id='+that.formData.id
    that.fetch();

    window.rbMessage = function (data) {
      data = JSON.parse(data);
      //                alert(data);
      if (data[0] == "videoUploadSuccess") {
        that.formData.video = [data[1]];
      }
    };
    window.getAppUploadVideoData = function (data) {
      that.formData.video = [JSON.parse(data)];
    };
  },
  watch: {
    formData() {},
  },
  destroyed() {},
  methods: {
    beforeUpload() {
      let that = this;
      // if (this.isAndroid()) {
      // appEvent({
      rbLink({
        name: "uploadVideo",
        query: {
          fileName:
              that.formData.baoming.mingcheng +
              "-" +
              that.formData.subject_name,
          url: "",
          limit: 1,
        },
      });
      // }
    },
    fetch() {
      let that = this;
      that.$api.get(
          "/api/isai/videoDetail",
          {
            id: that.formData.id,
          },
          (res) => {
            that.formData = Object.assign(that.formData, res.data);
            if (res.data.baoming.memberstatus != 6 && res.data.baoming.memberstatus != -2) {
              Toast("报名尚未成功,无法进行操作");
            } else {
              that.canSubmit = true;
            }
          },
          (res) => {
            console.log("没有登录");
            if (res.code == 401 || res.code == 402) {
              that.loginShow = true;
            } else {
              Toast(res.msg);
            }
          }
      );
    },
    onQuestion() {
      console.log("onQuestion");
    },
    
    onSubmit(values) {
      console.log("onSubmit-values", values);
      console.log("submitType", this.submitType);

      let that = this;
      console.log(that.formData);
      that.formValidate = true;
      for (let field in that.formData) {
        if (that.formData.pic.length == 0) {
          // Toast('请上传照片');
          // return
        }
        if (this.formData.video.length == 0) {
          Toast("请上传视频");
          return;
        }
      }
      that.saveLoading = true;
      that.$api.post(
          "/api/isai/savesubjectvideo",
          { 
            'id' : that.formData.id, 
            'video' : that.formData.video,
            'pic' : that.formData.pic,
            'jizan_pic' : that.formData.jizan_pic,
            'jizan_count' : that.formData.jizan_count,
            'yundongyuan_count' : that.formData.yundongyuan_count,
          },
          (res) => {
            that.saveLoading = false;
              Toast('上传成功');

            appEvent({
              name: "saiApplyVideoReload",
              query: {},
            });
            appEvent({
              name: "saiApplyDetailReload",
              query: {},
            });

            setTimeout(() => {
              rbLink(
                  {
                    name: "ISaiApplyVideoList",
                    query: {
                      id: that.formData.baoming.id,
                    },
                  },
                  "back"
              );
            }, 1000);
          },
          (res) => {
            Toast.fail(res.msg);
            that.saveLoading = false;
          }
      );
    },
 

 
    save(values) {
      this.submitType = "save";
    },
    onVideoInputClick() {
      let that = this;
      console.log({
        name: "onVideoInputClick",
        query: {
          mingcheng: this.formData.baoming.mingcheng,
          subject_name: this.formData.subject_name,
        },
      });

      appEvent({
        name: "onVideoInputClick",
        query: {
          mingcheng: this.formData.baoming.mingcheng,
          subject_name: this.formData.subject_name,
        },
      });
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    submit(values) {
      this.submitType = "submit";
    },

    // 下载APP
    onDownload() {
      // 判断是ios还是安装
      if(window.isApp()) {
        if(window.isAndroid()) {
          appEvent({
            name: 'downloadFile',
            query: {
              name: 'file.name',
              url: "http://fir.dierqudao.com/859v",
            }
          });
          return
          rbLink({
            name: 'H5',
            query: {
              url: "http://fir.dierqudao.com/859v"
            }
          })


        } else {
// let url = URL(string: "itms-apps://itunes.apple.com/app/id 1142110895")
          appEvent({
            name: 'downloadFile',
            query: {
              name: 'file.name',
              url: "itms-apps://itunes.apple.com/app/1440159054",
            }
          });
          return
          rbLink({
            name: 'H5',
            query: {
              url: "itms-apps://itunes.apple.com/app/1440159054"
            }
          })
        }
      }
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    delVideo(){  
        this.$refs['vu'].delImg(0) ;
    },
    playVideo(){ 
        this.$refs['vu'].play(0) ;
    }, 
    onCopy() {
        Toast.success('复制成功，请打开电脑浏览器粘贴网址') 
    }
  },
};
</script>



// WEBPACK FOOTER //
// SaiApplyFormUploadVideo.vue?0adef262